import { useState, useEffect } from 'react';

import {
  Carousel,
  CarouselContent,
  CarouselItem
} from '@/components/ui/carousel';
import Image from '@/components/common/Image';

const ImageCarousel = ({ profileImages }) => {
  const [api, setApi] = useState(null);
  const [current, setCurrent] = useState(0);
  // const [count, setCount] = useState(0);

  useEffect(() => {
    if (!api) {
      return;
    }

    // setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap() + 1);

    api.on('select', () => {
      setCurrent(api.selectedScrollSnap() + 1);
    });
  }, [api]);

  const handleDotClick = (index) => {
    if (!api) {
      return;
    }
    api.scrollTo(index);
  };

  if (profileImages.length === 0) {
    return (
      <div className="min-h-20 flex items-center justify-center text-muted-foreground">
        No profile images uploaded.
      </div>
    );
  }

  return (
    <>
      <div className="relative pb-6">
        <Carousel setApi={setApi}>
          <CarouselContent>
            {profileImages.map((profileImage) => (
              <CarouselItem key={profileImage.id}>
                <div>
                  <div>
                    <div className="flex items-center justify-center">
                      <Image url={profileImage.imageUrlMedium} />
                    </div>
                  </div>
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
        </Carousel>
        <div className="absolute bottom-1 left-1/2 transform -translate-x-1/2 flex gap-2">
          {profileImages.map((_, index) => (
            <div
              key={index}
              className={`w-3 h-3 rounded-full transition-colors ${
                index === current - 1
                  ? 'bg-primary'
                  : 'bg-muted-foreground/50 hover:bg-muted-foreground/75'
              }`}
              onClick={() => handleDotClick(index)}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default ImageCarousel;
